import { PhotographIcon } from '@heroicons/react/outline';

export function ImageFileIcon() {
  return <PhotographIcon className="h-full text-file-image-enabled" />;
}
